import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { IPagination } from "./AdminDataApi"

// export const AddGBPApi = async (payload: string) => {
//     const response = await AxiosInstance.post(
//         apiRoutes?.mapchecinaddbgp,
//         { code: payload }
//     )
//     return response
// }

export const GetGBPApi = async () => {
    const response = await AxiosInstance.get(
        // apiRoutes?.mapcheckingetgbp,
        apiRoutes?.checkinBusinessSimplified,
    )
    return response
}

export const getCheckinBusinessPaginatedApi = async (payload: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.checkinBusinessPaginated, payload)
    return response
}

export const GetGBPBusinessDetailsApi = async (id: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.mapcheckingetgbpbusinessdetails, { business_id: id }
    )
    return response
}

// export const getListGBPApi = async () => {
//     const response = await AxiosInstance.get(
//         apiRoutes?.listCheckinBusiness,
//     )
//     return response
// }

export const getListGBPPaginatedApi = async (payload: { page: number, limit: number, keyword: string, email: string[], sort_by?: string, sort_order?: string }) => {
    const response = await AxiosInstance.post(
        apiRoutes?.listCheckinBusinessPaginated, payload
    )
    return response
}
export const importGBPApi = async (business_ids: string[]) => {
    const response = await AxiosInstance.post(
        apiRoutes?.importCheckinBusiness, { business_ids }
    )
    return response
}

export const GetGBPBusinessApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.adminGBPBusiness)
    return response
}

export const adminGBPBusinessPaginationApi = async (payload: IPagination) => {
    const response = await AxiosInstance.post(apiRoutes?.adminGBPBusinessPagination, payload)
    return response
}

export const GBPBusinessEnableApi = async (business_id: string) => {
    const response = await AxiosInstance.post(apiRoutes?.adminGBPBusinessEnable, { business_id })
    return response
}

export const SubscribeGBPApi = async (id: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.subscribegbp,
        { business_id: id }
    )
    return response
}


export const ConfirmPayemntGBPApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes?.addonConfirmMapCheckInPurchase,
        payload
    )
    return response
}

export const GetDashboardApi = async (id: string) => {
    const response = await AxiosInstance.post(
        apiRoutes?.mapcheckingedashboard,
        { checkin_id: id }
    )
    return response
}

export const getPostsPaginatedApi = async (payload: {
    checkin_id: string,
    page: number,
    limit: number,
    keyword?: string,
    status?: string,
    employee_id?: string,
    platform?: string,
    date_from?: string,
    date_to?: string,
    sort_by?: string,
    sort_order?: string
}) => {
    const response = await AxiosInstance.post(
        apiRoutes?.getPostsPaginated,
        payload
    )
    return response
}

export const ConnectFacebookPageApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.connectFacebookPage, payload)
    return response
}

export const ConnectInstagramPageApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.connectInstagramPage, payload)
    return response
}

export const connectInstagramPortfolioApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.connectInstagramPortfolio, payload)
    return response
}

export const IntigrationApi = async (payload: any) => {

    const response = await AxiosInstance.post(apiRoutes?.intigration, payload)
    return response

}

export const removeIntigrationApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.removeIntegration, payload)
    return response
}

export const transferAccountApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.adminTransferAccount, payload)
    return response
}

export const listManagedBusinessApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.listManagedBusiness)
    return response
}

export const deleteCheckinBusinessApi = async (payload: { business_id: string, force?: boolean }) => {
    const response = await AxiosInstance.post(apiRoutes?.deleteCheckinBusiness, payload)
    return response
}
export const disconnectJobberApi = async (payload: { businessId: string }) => {
    const response = await AxiosInstance.post(apiRoutes?.disconnectJobber, payload)
    return response
}
